<template>
  <div :class="['allot_pop_right_mask', 'animated', showAnimated ? 'findinMask' : 'findOutMask']">
      <div :class="['allot_pop_right', 'animated', showAnimated ? 'fadeInRightBig' : 'fadeOutRightBig']">
        <div class="allot_title">
            <p style="text-align:center;">请选择设备</p>
        </div>

        <el-row style="margin: 10px 0; padding: 10px 20px; background: white;">
          <el-col :span="4" style="width: 100px;">已选择设备</el-col>
          <el-col :span="20" style="min-width: 500px; height: 90px; overflow-y: scroll; background: #f9f9f9;">
            <el-tag
              v-for="deviceCode in selectedDevices"
              :key="deviceCode"
              :closable="true"
              type="success"
              :close-transition="false"
              @close="handleClose(deviceCode)"
              style="margin: 3px 5px;"
              > 
              {{deviceCode}}  
            </el-tag>
          </el-col>
        </el-row>
        <div style="background:white; position: absolute; left:0; right:0; bottom: 0; top: 188px">
          <div style="text-align: center; padding: 10px 20px; border-bottom: 1px solid #d1dbe5;">
            <span style="line-height: 36px;">设备列表</span>
            <div class="search-box" style="float:right">
              <el-input placeholder="编号/昵称/地址" v-model="searchValue">
                <el-select v-model="searchSelect" slot="prepend" placeholder="请选择">
                  <el-option label="设备编号" value="0"></el-option>
                  <el-option label="设备昵称" value="1"></el-option>
                  <el-option label="设备地址" value="2"></el-option>
                </el-select>
                <el-button slot="append" icon="search" @click="queryDevicByKeyword"></el-button>
              </el-input>
            </div>
          </div>
          <div style="position: absolute; left: 10px; right: 10px; top: 67px; bottom: 57px; overflow-y: scroll">
            <el-table
              ref="deviceSelect"
              v-loading="table_loading"
              element-loading-text="拼命加载中"
              :data="deviceData"
              stripe
              border
              fit
              style="width: 100%"
              @selection-change="deviceSelectionChange">
              <el-table-column
                type="selection"
                width="40">
              </el-table-column>
              <el-table-column
                prop="deviceCode"
                header-align="center"
                min-width="95"
                label="设备编号">
              </el-table-column>
              <el-table-column
                prop="name"
                header-align="center"
                min-width="200"
                label="昵称">
              </el-table-column>
              <el-table-column
                prop="owner"
                header-align="center"
                min-width="95"
                label="设备所属">
              </el-table-column>
              </el-table-column>
              <!-- <el-table-column
                prop="spase"
                header-align="center"
                min-width="95"
                label="所在场景">
              </el-table-column> -->
              <el-table-column
                prop="address"
                header-align="center"
                min-width="250"
                label="设备地址">
              </el-table-column>
              <el-table-column
                prop="status"
                header-align="center"
                width="80"
                label="状态">
                <template scope="scope">
                <el-tag :type="scope.row.status === '离线' ? 'danger' : 'success'"
                close-transition>{{scope.row.status}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="pager"
                header-align="center"
                width="100"
                label="货物量">
                <template scope="scope">
                <span v-if="scope.row.pager/scope.row.paperVolume > 0.75" 
                style="color:#13CE66">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
                <span v-else-if="scope.row.pager/scope.row.paperVolume > 0.50" 
                style="color:#b8ce13">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
                <span v-else-if="scope.row.pager/scope.row.paperVolume > 0.25" 
                style="color:#F7BA2A">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
                <span v-else 
                style="color:#FF4949">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="table_pagination" style="position: absolute; bottom: 15px; right: 10px; left: 10px; text-align: right;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal">
            </el-pagination>
          </div>
        </div>
        
        <span @click="boxColose" 
            style="position: absolute; top: 0;left:0;padding:10px;color:  #FF4949">
            <i class="el-icon-close Danger"></i>
        </span>
      </div>
  </div>
</template>
<script>
import $axios from '../../https/config'
import {isNull} from '../../js/tool'

export default {
  props: ['chooseDeviceCodes'],
  data () {
    return {
      showAnimated: true,
      searchSelect: '0',
      selectedDevices: this.chooseDeviceCodes,
      pageTotal: 0,
      pageSize: 10,
      pageNo: 1,
      table_loading: false,
      deviceData: [],
      searchValue: '',
      nowSelect: []
    }
  },
  created: function () {
    this.pageNo = 1
    this.queryDeviceList(this.pageNo, this.pageSize)
    console.log(this.chooseDeviceCodes)
  },
  methods: {
    queryDevicByKeyword () {
      this.pageNo = 1
      if (isNull(this.searchValue)) {
        this.queryDeviceList(this.pageNo, this.pageSize)
      } else {
        this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (isNull(this.searchValue)) {
        this.queryDeviceList(this.pageNo, this.pageSize, '')
      } else {
        this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
      }
    },
    handleCurrentChange (val) {
      this.pageNo = val
      if (isNull(this.searchValue)) {
        this.queryDeviceList(this.pageNo, this.pageSize, '')
      } else {
        this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
      }
    },
    deviceSelectionChange (val) {
      this.nowSelect = []
      this.nowSelect.push(val)
      for (var i = 0; i < val.length; i++) {
        if (this.selectedDevices.indexOf(val[i].deviceCode) === -1) {
          this.selectedDevices.push(val[i].deviceCode)
        }
      }
    },
    queryDeviceList (tPageNo, tPageSize) {
      var _this = this
      var params = {
        pageNo: tPageNo,
        pageSize: tPageSize,
        isAssigned: 1
      }
      this.table_loading = true
      this.deviceData = []
      $axios.get('/device/getDeviceList', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              var item = {
                deviceCode: itemData.deviceCode,
                id: itemData.id,
                name: itemData.alias,
                owner: itemData.nickName,
                payStatus: isNull(itemData.devicePoint) ? '无' : itemData.devicePoint.status,
                payPoints: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.point,
                payCharge: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.charge,
                // spase: _this.getDeviceSpaceValue(_this.spaceTypeList, itemData.ownerType),
                address: itemData.address,
                status: itemData.isOnline === 0 ? '离线' : '在线',
                pager: itemData.paperNum,
                paperVolume: itemData.paperVolume
              }
              resData.push(item)
            }
            _this.deviceData = resData
          }
        } else {
        }
        _this.table_loading = false
      }, function () {
      })
    },
    queryDeviceListByKey (tType, tKeyWord, tPageNo, tPageSize) {
      var _this = this
      var params = {
        type: tType,
        keyword: tKeyWord,
        pageNo: tPageNo,
        pageSize: tPageSize,
        isAssigned: 1
      }
      this.table_loading = true
      this.deviceData = []
      $axios.get('/device/query', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              var item = {
                deviceCode: itemData.deviceCode,
                id: itemData.id,
                name: itemData.alias,
                owner: itemData.nickName,
                payStatus: isNull(itemData.devicePoint) ? '无' : itemData.devicePoint.status,
                payPoints: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.point,
                payCharge: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.charge,
                // spase: _this.getDeviceSpaceValue(_this.spaceTypeList, itemData.ownerType),
                address: itemData.address,
                status: itemData.isOnline === 0 ? '离线' : '在线',
                pager: itemData.paperNum,
                paperVolume: itemData.paperVolume
              }
              resData.push(item)
            }
            _this.deviceData = resData
          }
        } else {
        }
        _this.table_loading = false
      }, function () {
      })
    },
    boxColose () {
      this.showAnimated = false
      var _this = this
      setTimeout(function () {
        _this.$emit('closeSelectDevicePop', _this.selectedDevices)
      }, 500)
    },
    handleClose (deviceCode) {
      this.selectedDevices.splice(this.selectedDevices.indexOf(deviceCode), 1)
    }
  }
}
</script>


<style lang="scss">
 .search-box {
    .el-select .el-input {
      width: 110px;
    }
  }
  .allot_pop_right_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 200;
  }
  .allot_pop_right {
    top: 0;
    right: 0;
    left: 20%;
    bottom: 0;
    z-index: 201;
    position: fixed;
    background: #eef1f6;

    .allot_title {
        background: white; 
        padding: 10px;
        border-bottom: 1px solid #ccc;

        p {
            margin:0;
            padding: 5px;
            color: black;
            font-size: 20px;
            font-weight: 500;
        }
        span {
            margin-right: 10px;
        }
    }
  }

  .animated {
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }

    .animated.infinite {
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }

    .animated.hinge {
      -webkit-animation-duration: 2s;
      animation-duration: 2s;
    }

    @-webkit-keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }

    @keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }
    }

    .fadeInRightBig {
      -webkit-animation-name: fadeInRightBig;
      animation-name: fadeInRightBig;
    }

    @-webkit-keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    @keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }
    .findinMask {
      -webkit-animation-name: findinMask;
      animation-name: findinMask;
    }



    @-webkit-keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    @keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    .fadeOutRightBig {
      -webkit-animation-name: fadeOutRightBig;
      animation-name: fadeOutRightBig;
    }

    @-webkit-keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }

    @keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }
    .findOutMask {
      -webkit-animation-duration: 0.5s;
      animation-duration: 0.5s;
      -webkit-animation-name: findOutMask;
      animation-name: findOutMask;
    }
</style> 



// WEBPACK FOOTER //
// src/page/adMgr/adSelectDevice.vue